module.exports = __webpack_public_path__ + "img/george-washington.366deadd.png";